var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColleges3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.27 21.663c0 11.873-9.626 21.5-21.5 21.5-11.873 0-21.495-9.627-21.495-21.5s9.627-21.5 21.5-21.5 21.5 9.627 21.5 21.5h-.005Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.27 21.663c0 11.873-9.626 21.5-21.5 21.5-11.873 0-21.495-9.627-21.495-21.5s9.627-21.5 21.5-21.5 21.5 9.627 21.5 21.5h-.005Z",
    fill: "#3FB7D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.27 21.663v-2h-2v2h2Zm.005 0v2h2v-2h-2Zm-2.005 0c0 10.769-8.73 19.5-19.5 19.5v4c12.978 0 23.5-10.522 23.5-23.5h-4Zm-19.5 19.5c-10.768 0-19.495-8.73-19.495-19.5h-4c0 12.978 10.517 23.5 23.495 23.5v-4Zm-19.495-19.5c0-10.769 8.731-19.5 19.5-19.5v-4c-12.978 0-23.5 10.522-23.5 23.5h4Zm19.5-19.5c10.769 0 19.5 8.731 19.5 19.5h4c0-12.978-10.522-23.5-23.5-23.5v4Zm21.5 17.5h-.005v4h.005v-4Z",
    fill: "#222",
    mask: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.775 25.331v1.13l7.821-3.694 2.044-.963 4.9-2.313v-1.13l-1.417.671-6.604 3.117-6.744 3.182Z",
    fill: "#665C7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m7.002 18.361 1.421.671 6.188 2.918 7.164 3.381 6.744-3.182 6.604-3.117 1.416-.67-14.764-4.785L7.002 18.36Z",
    fill: "#534B64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.775 13.577V25.33l6.744-3.187 6.604-3.111 1.42-.672-14.768-4.784Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.067 21.407v4.485c0 2.886 4.608 5.226 10.284 5.226 5.676 0 10.284-2.34 10.284-5.226v-4.088l-2.043.963-7.822 3.69-8.307-3.92-2.396-1.134v.004Z",
    fill: "#4C455C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.067 21.407v2.41c2.564.128 5.557 1.54 8.046 4.03a15.392 15.392 0 0 1 2.512 3.266c.137 0 .27 0 .406-.009a15.468 15.468 0 0 1 2.507-3.257c2.19-2.19 4.767-3.545 7.098-3.928v-2.115l-2.044.967-7.821 3.69-8.312-3.92-2.396-1.134h.004Z",
    fill: "#C7C5CC",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.002 18.362v1.13l4.065 1.915 2.397 1.134 8.311 3.92v-1.13l-7.164-3.38-6.188-2.919-1.421-.67Z",
    fill: "#665C7A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.16 28.39a.675.675 0 0 0 .675-.676v-5.87a.675.675 0 0 0-.437-.631l-7.385-2.777a.674.674 0 1 0-.476 1.263l6.947 2.613v5.402c0 .371.3.676.675.676Z",
    fill: "#E7EBEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m29 26.408.058-.013c-.013 0-.03 0-.044.009-.005 0-.01 0-.014.004Z",
    fill: "#F2F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.679 32.468a.488.488 0 0 0 .64-.256l.878-2.074-.349 2.613a.487.487 0 0 0 .42.547c.022 0 .044.005.061.005.243 0 .45-.181.486-.424l.34-2.556.34 2.556c.03.247.242.424.485.424.022 0 .04 0 .062-.005a.485.485 0 0 0 .42-.547l-.35-2.613.879 2.074a.486.486 0 0 0 .64.256.492.492 0 0 0 .26-.64l-2.286-5.411s-.013-.022-.018-.036l-.04-.066c-.012-.022-.035-.04-.052-.057-.018-.018-.036-.035-.058-.049a.394.394 0 0 0-.137-.066c-.017-.009-.035-.009-.052-.013a.399.399 0 0 0-.177 0 .117.117 0 0 0-.053.013.355.355 0 0 0-.141.07c-.018.014-.04.027-.058.045-.017.018-.035.035-.052.057a.167.167 0 0 0-.04.066c-.01.014-.014.027-.018.036l-2.286 5.411a.485.485 0 0 0 .26.64h-.004Z",
    fill: "#E1E3E3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.283 26.139s-.027-.009-.04-.009c.018 0 .036.005.054.013-.005 0-.01-.004-.014-.004Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 27.776a1.656 1.656 0 1 0 3.311 0 1.656 1.656 0 0 0-3.311 0Z",
    fill: "#E1E6E5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m31.733 32.415-10.73 10.726c-10.44-.362-18.99-8.174-20.494-18.287l6.493-6.497v1.13l4.065 1.92v4.485c0 2.886 4.604 5.226 10.284 5.226h.274c.137 0 .269 0 .406-.01 1.867-.061 3.597-.374 5.058-.873l-.675 1.598a.492.492 0 0 0 .26.64.486.486 0 0 0 .64-.256l.879-2.08-.345 2.618c-.04.265.15.512.42.547h.061c.243 0 .45-.18.486-.428l.34-2.555.34 2.555a.49.49 0 0 0 .485.428h.062a.487.487 0 0 0 .42-.547l-.345-2.617.878 2.079a.485.485 0 0 0 .64.256.506.506 0 0 0 .098-.053v-.005Z",
    fill: "#C1C0C6",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.54 19.487-4.905 4.908v-2.59l4.904-2.318Z",
    fill: "#C1C0C6",
    style: {
      mixBlendMode: "multiply"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColleges3);
export default __webpack_public_path__ + "static/media/colleges 3.d537f320ace97fdaf83178b6b193bb59.svg";
export { ForwardRef as ReactComponent };